module.exports = __webpack_public_path__ + "static/media/about.d253d905.jpg";